import React from 'react';
import { StyledWrapper, StyledSwatch, StyledTotalColors, StyledSwatchFrame, styles } from './SwatchColorGridStyles';
import { useSwatchColorGrid } from './useSwatchColorGrid';
import type { SwatchColorGridProps } from './types';
import { Box, useTheme } from '@withjoy/joykit';

export const FRAME_PADDING_X = '0.5rem'; // .25rem * 2
export const COLUMN_GAP = '0.5rem';

export const SwatchColorGrid: React.FC<SwatchColorGridProps> = (props: SwatchColorGridProps) => {
  const { optionsToRender, overflowCount, colorSelected, columnCount, alignment, handleMouseClick, handleMouseOver, handleMouseExit, swatchSize } = useSwatchColorGrid(props);
  const { checkAvailability = false, hasDarkBackground = false } = props;
  const theme = useTheme();
  const rawSwatchSize = theme.sizes[swatchSize] || theme.sizes[6];

  return (
    <StyledWrapper
      __css={styles.root}
      justifyContent={alignment}
      style={{
        maxWidth: `calc((${columnCount} * ${rawSwatchSize}) + (${columnCount} * ${2} * ${FRAME_PADDING_X}) + (${columnCount - 1} * ${COLUMN_GAP}))`,
      }}
    >
      {optionsToRender.map(option => {
        return (
          (option.color || option.imageUrl) && (
            <StyledSwatchFrame
              as="button"
              key={option.id}
              __css={styles.swatchFrame}
              onClick={(e: React.MouseEvent) => handleMouseClick(e, option)}
              onMouseLeave={(e: React.MouseEvent) => handleMouseExit(e, option)}
              onMouseEnter={(e: React.MouseEvent) => handleMouseOver(e, option)}
              aria-label={option.label}
            >
              <StyledSwatch
                aria-label={option.label}
                __css={styles.swatch}
                _after={{
                  opacity: colorSelected === option.id ? 1 : 0,
                }}
                data-readonly={(checkAvailability && option.notAvailable) || undefined}
                size={swatchSize}
                style={{ backgroundColor: option.color || undefined, backgroundImage: option.imageUrl ? `url(${option.imageUrl})` : undefined }}
              />
            </StyledSwatchFrame>
          )
        );
      })}

      {overflowCount > 0 && (
        <Box
          as="button"
          __css={styles.swatchFrame}
          onClick={(e: React.MouseEvent) => props.onViewMoreClick?.(e)}
        >
          <StyledTotalColors
            __css={hasDarkBackground ? styles.overflowCountDarkBg : styles.overflowCount}
            size={swatchSize}
            onClick={(e: React.MouseEvent) => props.onViewMoreClick?.(e)}
          >
            +{overflowCount}
          </StyledTotalColors>
        </Box>
      )}
    </StyledWrapper>
  );
};
